<div class="micard overflow-hidden">

    <div class="micard-header" style="cursor: pointer;" title="Show projectEl.name">
        <div>
            <h5 *ngIf="engineService.selectedEngine != undefined" class="list-title">{{engine?.name}}</h5>
        </div>
    </div>


    <div class="details-body" *ngIf="engineService.selectedEngine == undefined">
        <p>Please Select a Power Train</p>
    </div>

    <div class="details-body" *ngIf="engineService.selectedEngine != undefined">
        <div class="row">
            <div class="col-sm-12 property-box">
                <div class="row">
                    <div class="property-name">
                        Creation
                    </div>
                </div>
                <div class="row">
                    <div class="property-value">
                        {{engine?.date}}
                    </div>
                </div>

            </div>
        </div>
        <div class="row">

            <div class="col-sm-12 property-box">
                <div class="row">
                    <div class="property-name">
                        Installed Power
                    </div>
                </div>
                <div class="row">
                    <div class="property-value">
                        {{engine?.Pi_kw}} kW
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-sm-6 property-box">
                <div class="row">
                    <div class="property-name">
                        Gear Ratio
                    </div>
                </div>
                <div class="row">
                    <div class="property-value">
                        {{engine?.Z}}
                    </div>
                </div>
            </div>
            <div class="col-sm-6 property-box">
                <div class="row">
                    <div class="property-name">
                        &eta;<sub>M</sub>
                    </div>
                </div>
                <div class="row">
                    <div class="property-value">
                        {{engine?.eta_m}}
                    </div>
                </div>
            </div>
        </div>

        <hr>
        <div class="row" *ngIf="engineService.selectedEngine != undefined">
            <div class="col-sm-6 card-button action-icon" style="text-align: center;">
                <i class="bx bxs-edit-alt font-size-22 action-icon" (click)="onEdit()" title="Edit"></i>
            </div>

            <div class="col-sm-6 card-button action-icon" style="text-align: center;">
                <i class="bx bxs-trash-alt font-size-22 action-icon" (click)="onTrash()" title="Delete"></i>
            </div>

        </div>


    </div>
</div>